var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.45 2.758C12.908 2.292 14.425 2 16.058 2c7.759 0 14 6.242 13.942 14 0 7.7-6.3 14-14 14S2 23.758 2 16c0-3.693 1.431-7.004 3.733-9.502v10.027c.117 5.658 4.667 10.15 10.325 10.15A10.307 10.307 0 0 0 26.383 16.35 10.307 10.307 0 0 0 16.058 6.025h-2.333v1.633h2.508c4.784.059 8.575 3.967 8.575 8.692 0 4.783-3.908 8.692-8.691 8.692-4.784 0-8.692-3.909-8.692-8.692V4.975a13.206 13.206 0 0 1 2.45-1.517v12.95c.058 3.442 2.8 6.184 6.242 6.184a6.25 6.25 0 0 0 6.241-6.242 6.25 6.25 0 0 0-6.241-6.242h-2.334v1.634h2.45c2.509.058 4.55 2.158 4.55 4.666a4.68 4.68 0 0 1-4.666 4.667 4.68 4.68 0 0 1-4.667-4.667V2.758zm-5.717 3.74c.244-.264.497-.52.759-.765-.197.158-.368.342-.53.517-.077.084-.153.166-.229.242v.006zM16.058 13.9h-2.333v2.392c0 1.225 1.05 2.275 2.333 2.275a2.34 2.34 0 0 0 2.334-2.334 2.34 2.34 0 0 0-2.334-2.333z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBor);
export default __webpack_public_path__ + "static/media/BOR.3e03ce54fae881cde5d1767c88129c8b.svg";
export { ForwardRef as ReactComponent };